import * as privacyPolicyAPI from 'login-apis/privacyPolicyAPI';
import { createAction } from 'redux-actions';
import { ERROR_FETCH_PRIVACY_POLICY, START_FETCH_PRIVACY_POLICY, SUCCESS_FETCH_PRIVACY_POLICY } from './actionTypes';

const startGetPrivacyPolicy = createAction(START_FETCH_PRIVACY_POLICY);
const getPrivacyPolicySuccess = createAction(SUCCESS_FETCH_PRIVACY_POLICY, content => content);
const getPrivacyPolicyError = createAction(ERROR_FETCH_PRIVACY_POLICY, () => 'Error fetching Privacy Policy.');

export function getPrivacyPolicyText() {
  return async function(dispatch) {
    dispatch(startGetPrivacyPolicy());
    try {
      const res: any = await privacyPolicyAPI.getPrivacyPolicy();
      dispatch(getPrivacyPolicySuccess(res.data.htmlText as string));
    } catch (err) {
      dispatch(getPrivacyPolicyError());
    }
  };
}
